import { defineComponent as j, inject as D, ref as K, h as t, Fragment as H } from "vue";
import V from "./ghl-ui.es1485.js";
import X from "./ghl-ui.es1486.js";
import q from "./ghl-ui.es1487.js";
import { getColKey as G, isColumnSorting as J, isColumnFilterable as U, isColumnSortable as O, createNextSorter as Q, clampValueFollowCSSRules as Y, isColumnResizable as Z } from "./ghl-ui.es996.js";
import { dataTableInjectionKey as ee } from "./ghl-ui.es992.js";
import te from "./ghl-ui.es1488.js";
import { pxfy as B } from "./ghl-ui.es902.js";
import { formatLength as ae } from "./ghl-ui.es1026.js";
import { happensIn as E } from "./ghl-ui.es981.js";
import le from "./ghl-ui.es245.js";
import re from "./ghl-ui.es380.js";
function P(d) {
  return typeof d.title == "function" ? d.title(d) : d.title;
}
const ue = j({
  name: "DataTableHeader",
  props: {
    discrete: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    const {
      mergedClsPrefixRef: d,
      scrollXRef: a,
      fixedColumnLeftMapRef: f,
      fixedColumnRightMapRef: c,
      mergedCurrentPageRef: k,
      allRowsCheckedRef: p,
      someRowsCheckedRef: y,
      rowsRef: x,
      colsRef: S,
      mergedThemeRef: b,
      checkOptionsRef: v,
      mergedSortStateRef: m,
      componentId: w,
      mergedTableLayoutRef: T,
      headerCheckboxDisabledRef: $,
      onUnstableColumnResize: z,
      doUpdateResizableWidth: M,
      handleTableHeaderScroll: L,
      deriveNextSorter: W,
      doUncheckAll: _,
      doCheckAll: C
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = D(ee), u = K({});
    function R(l) {
      const r = u.value[l];
      return r == null ? void 0 : r.getBoundingClientRect().width;
    }
    function s() {
      p.value ? _() : C();
    }
    function e(l, r) {
      if (E(l, "dataTableFilter") || E(l, "dataTableResizable") || !O(r))
        return;
      const i = m.value.find((n) => n.columnKey === r.key) || null, o = Q(r, i);
      W(o);
    }
    const g = /* @__PURE__ */ new Map();
    function F(l) {
      g.set(l.key, R(l.key));
    }
    function N(l, r) {
      const i = g.get(l.key);
      if (i === void 0)
        return;
      const o = i + r, n = Y(o, l.minWidth, l.maxWidth);
      z(o, n, l, R), M(l, n);
    }
    return {
      cellElsRef: u,
      componentId: w,
      mergedSortState: m,
      mergedClsPrefix: d,
      scrollX: a,
      fixedColumnLeftMap: f,
      fixedColumnRightMap: c,
      currentPage: k,
      allRowsChecked: p,
      someRowsChecked: y,
      rows: x,
      cols: S,
      mergedTheme: b,
      checkOptions: v,
      mergedTableLayout: T,
      headerCheckboxDisabled: $,
      handleCheckboxUpdateChecked: s,
      handleColHeaderClick: e,
      handleTableHeaderScroll: L,
      handleColumnResizeStart: F,
      handleColumnResize: N
    };
  },
  render() {
    const {
      cellElsRef: d,
      mergedClsPrefix: a,
      fixedColumnLeftMap: f,
      fixedColumnRightMap: c,
      currentPage: k,
      allRowsChecked: p,
      someRowsChecked: y,
      rows: x,
      cols: S,
      mergedTheme: b,
      checkOptions: v,
      componentId: m,
      discrete: w,
      mergedTableLayout: T,
      headerCheckboxDisabled: $,
      mergedSortState: z,
      handleColHeaderClick: M,
      handleCheckboxUpdateChecked: L,
      handleColumnResizeStart: W,
      handleColumnResize: _
    } = this, C = t("thead", {
      class: `${a}-data-table-thead`,
      "data-n-id": m
    }, x.map((s) => t("tr", {
      class: `${a}-data-table-tr`
    }, s.map(({
      column: e,
      colSpan: g,
      rowSpan: F,
      isLast: N
    }) => {
      var l, r;
      const i = G(e), {
        ellipsis: o
      } = e, n = () => e.type === "selection" ? e.multiple !== !1 ? t(H, null, t(le, {
        key: k,
        privateInsideTable: !0,
        checked: p,
        indeterminate: y,
        disabled: $,
        onUpdateChecked: L
      }), v ? t(te, {
        clsPrefix: a
      }) : null) : null : t(H, null, t("div", {
        class: `${a}-data-table-th__title-wrapper`
      }, t("div", {
        class: `${a}-data-table-th__title`
      }, o === !0 || o && !o.tooltip ? t("div", {
        class: `${a}-data-table-th__ellipsis`
      }, P(e)) : o && typeof o == "object" ? t(re, Object.assign({}, o, {
        theme: b.peers.Ellipsis,
        themeOverrides: b.peerOverrides.Ellipsis
      }), {
        default: () => P(e)
      }) : P(e)), O(e) ? t(V, {
        column: e
      }) : null), U(e) ? t(X, {
        column: e,
        options: e.filterOptions
      }) : null, Z(e) ? t(q, {
        onResizeStart: () => {
          W(e);
        },
        onResize: (h) => {
          _(e, h);
        }
      }) : null), A = i in f, I = i in c;
      return t("th", {
        ref: (h) => d[i] = h,
        key: i,
        style: {
          textAlign: e.titleAlign || e.align,
          left: B((l = f[i]) === null || l === void 0 ? void 0 : l.start),
          right: B((r = c[i]) === null || r === void 0 ? void 0 : r.start)
        },
        colspan: g,
        rowspan: F,
        "data-col-key": i,
        class: [`${a}-data-table-th`, (A || I) && `${a}-data-table-th--fixed-${A ? "left" : "right"}`, {
          [`${a}-data-table-th--hover`]: J(e, z),
          [`${a}-data-table-th--filterable`]: U(e),
          [`${a}-data-table-th--sortable`]: O(e),
          [`${a}-data-table-th--selection`]: e.type === "selection",
          [`${a}-data-table-th--last`]: N
        }, e.className],
        onClick: e.type !== "selection" && e.type !== "expand" && !("children" in e) ? (h) => {
          M(h, e);
        } : void 0
      }, n());
    }))));
    if (!w)
      return C;
    const {
      handleTableHeaderScroll: u,
      scrollX: R
    } = this;
    return t("div", {
      class: `${a}-data-table-base-table-header`,
      onScroll: u
    }, t("table", {
      ref: "body",
      class: `${a}-data-table-table`,
      style: {
        minWidth: ae(R),
        tableLayout: T
      }
    }, t("colgroup", null, S.map((s) => t("col", {
      key: s.key,
      style: s.style
    }))), C));
  }
});
export {
  ue as default
};
